<template>
  <span>
    <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
      <img class="background_image" src="./../assets/images/Asset 37.png" alt="">
      <img draggable="false" class="clickable" id="quit_btn_top" @click="goToHome()" src="./../assets/images/Asset 29.png" alt="">

      <span id="top_text">Waar geloof jij in?</span>

      <span id="bottom_text">Klik op een vakje voor meer info</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToGamePage() {
      this.$router.push('/game');
    },
    GoToPhagwaGame() {
      this.$router.push('/phagwagame');
    },
    GoToKerstmisGame() {
      this.$router.push('/kerstmisgame');
    },
  },

  computed: {}
};
</script>

<style>
  #top_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 5%;
    width: 40%;
    left: 30%;
    color: white;
    font-size: 4vw;
    text-align: center;
  }

  #bottom_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 45%;
    width: 70%;
    left: 15%;
    color: white;
    font-size: 4vw;
    text-align: center;
  }

  #quit_btn_top {
    position: absolute;
    top: 5%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #table {
    position: absolute;
    top: 75%;
    left: 28%;
    width: 45%;
    height: auto;
  }
</style>


